import { MenuItem } from "@material-ui/core";
import React, { useCallback, useEffect, useState } from "react";
import SelectDropOtions from "../../../components/SelectDropOtions";
import { useStylesEmergency } from "../helpers/emerManageEvtOp";

export const SelectStatus = ({ onChange = () => {}, value = "", forFilter = false, disabled = false }) => {
    const classsStatus = useStylesEmergency();
    const options = [
        { id: "3", label: "Cancel" },
        { id: "2", label: "Completed" },
        { id: "1", label: "Processing" },
        { id: "0", label: "Pending" },
    ];
    const [stateValue, setStateValue] = useState(value);
    const [classAdd, setClassAdd] = useState("");

    useEffect(() => {
        setStateValue(value);
        if (value === "3") {
            setClassAdd("cancel");
        } else if (value === "2") {
            setClassAdd("complete");
        } else if (value === "1") {
            setClassAdd("process");
        } else if (value === "0") {
            setClassAdd("pending");
        } else {
            setClassAdd("");
        }
    }, [value]);

    const handleOnChangeSelect = useCallback(
        val => {
            onChange(val);
            setStateValue(val);
            if (val === "3") {
                setClassAdd("cancel");
            } else if (val === "2") {
                setClassAdd("complete");
            } else if (val === "1") {
                setClassAdd("process");
            } else if (val === "0") {
                setClassAdd("pending");
            } else {
                setClassAdd("");
            }
        },
        [onChange, setClassAdd, setStateValue],
    );

    return (
        <SelectDropOtions
            // Completed class complete : pending class pending
            containerClass={`${classsStatus.selectStatus} ${classAdd}`}
            options={options}
            value={stateValue}
            onChange={handleOnChangeSelect}
            renderOption={option => (
                <MenuItem key={"stuts_" + option?.id} value={option?.id}>
                    {option?.label}
                </MenuItem>
            )}
            disabled={disabled}
            {...(forFilter && { placeholder: "ทั้งหมด" })}
        />
    );
};
